import { Component, OnInit, inject, model } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user.service';
import { UserFormComponent } from "../user-form/user-form.component";
import { ButtonModule } from 'primeng/button';
import { ProfileService } from '../../profile/services/profile.service';
import { AccessService } from '../../core/services/access.service';
import { User } from '../models/user.model';
import { UserInterface } from '../interfaces/user.interface';

@Component({
  selector: 'app-user-detailed',
  standalone: true,
  imports: [UserFormComponent, ButtonModule],
  templateUrl: './user-detailed.component.html',
  styleUrl: './user-detailed.component.css'
})
export class UserDetailedComponent implements OnInit {
  private route = inject(ActivatedRoute)
  private service = inject(UserService)

  protected profile = inject(ProfileService).profile
  protected access = inject(AccessService).access

  protected id!: string | null;

  protected value = model<User | undefined>(undefined)

  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Detalles del Usario')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.get(params.get('id'));
    });
  }

  private get(id: string | null) {
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      this.service.get(id).subscribe(data => {
        this.value.update(value => (value = new User(data as UserInterface)));
      });
    }
  }
}
